export default __webpack_public_path__ + "static/media/BC_444_BC_07235_tn.91ca00e1.jpg";